export default __webpack_public_path__ + "static/media/slide02.8fe9635b.jpg";